import { Card, CardContent } from '@/components/ui/card';

interface FAQ {
  question: string;
  answer: string;
}

interface PricingFAQProps {
  faqs: FAQ[];
}

const PricingFAQ = ({ faqs }: PricingFAQProps) => {
  return (
    <div className="max-w-4xl mx-auto mb-16">
      <div className="text-center mb-8">
        <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-base text-muted-foreground max-w-xl mx-auto">
          Got questions? We've got answers. Here are the most common questions about SeniorThrive plans.
        </p>
      </div>
      
      <div className="grid lg:grid-cols-2 gap-6">
        {faqs.map((faq, index) => (
          <Card key={index} className="transition-all duration-300 hover:shadow-lg">
            <CardContent className="pt-6">
              <h3 className="text-lg font-semibold text-foreground mb-3 leading-relaxed">
                {faq.question}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {faq.answer}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PricingFAQ;